// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__YHUOU","h1":"Footer_h1__PHkOL","icon":"Footer_icon__TnzTA"};